import gql from 'graphql-tag'

// Group Sessions
export const groupSessionsQuery = gql`
    query groupSessions($first: Int, $last: Int, $after: ID, $filters: GroupSessionFilter, $eventId: EventID!) {
        event(id:$eventId) {
            groupSessions(first: $first, last: $last, after: $after, filters: $filters) {
                edges {
                    node {
                        id
                        title
                        startsAt
                        endsAt
                        description
                        participants {
                            totalCount
                            edges {
                                node {
                                    company
                                    email
                                    firstName
                                    id
                                    jobtitle
                                    lastName
                                    mugshot
                                    about
                                    hasLoggedOn
                                }
                            }
                        }
                    }
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
                totalCount
            }
        }
    }
`
